export class APIDetails {
  id: number;
  apiKey: string;
  url: string;

  constructor(apiKey?: string, url?: string) {
    this.apiKey = apiKey;
    this.url = url;
  }
}

export class UrlDetails {
  url: string;

  constructor(url?: string) {
    this.url = url;
  }
}
